import { z } from "zod";

// Создаем схему для объекта personal
const PersonalSchema = z.object({
    phone: z.string().min(1, { message: "Phone is required" }),
    first_name: z.string().min(1, { message: "First name is required" }),
    last_name: z.string().min(1, { message: "Last name is required" }),
  });
  
  // Создаем основную схему для UserAdminForm
export const UserAdminFormSchema = z.object({
    id: z.number().int().positive(),
    email: z.string().email({ message: "Invalid email address" }),
    password: z.string().min(6, { message: "Password must be at least 6 characters long" }),
    inviter: z.number().int().positive().optional(),
    role_id: z.number().int().positive(),
    personal: PersonalSchema,
  });


  // Создаем основную схему для UserAdminForm
export const UserAdminFormFillSchema = z.object({
    email: z.string().email({ message: "Invalid email address" }),
    password: z.string().min(6, { message: "Password must be at least 6 characters long" }),
    inviter: z.number().int().positive().optional(),
    group_id: z.number().int().positive().optional(),
    role_id: z.string(),
    phone: z.string().min(1, { message: "Phone is required" }),
    first_name: z.string().min(1, { message: "First name is required" }),
    last_name: z.string().min(1, { message: "Last name is required" }),
  });


  export type UserAdminFormFillType = z.infer<typeof UserAdminFormFillSchema>;
